import React from 'react';
import {Filter, TextInput, FilterProps} from 'react-admin';

const WintypFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <TextInput source="code" alwaysOn/>
    </Filter>
);

export default WintypFilter;
